import { render, staticRenderFns } from "./SettingAdmins.vue?vue&type=template&id=371961b9&scoped=true&"
import script from "./SettingAdmins.vue?vue&type=script&lang=js&"
export * from "./SettingAdmins.vue?vue&type=script&lang=js&"
import style0 from "./SettingAdmins.vue?vue&type=style&index=0&id=371961b9&scoped=true&lang=css&"
import style1 from "./SettingAdmins.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371961b9",
  null
  
)

export default component.exports